import React from 'react';
import logo from './logo.svg';
import './App.css';
import TopBar from './components/TopBar/TopBar';
import Dashboard from './pages/Dashboard/Dashboard';

import {
  BrowserRouter as Router, 
  Switch, 
  Route, 
  Link
} from 'react-router-dom';

import Project from './pages/Project/Project';
import Profile from './pages/Profile/Profile';
import Proposal from './pages/Proposal/Proposal';






function App() {
  return (

    <Router>
    <div className="App">
      <TopBar></TopBar>
      <Route exact path="/"><Dashboard></Dashboard></Route>
      <Route path="/project/:id"><Project></Project></Route>   
      <Route path="/profile/:id"><Profile></Profile></Route>
      <Route path="/proposal/:id"><Proposal></Proposal></Route>
    </div>
    </Router>
  );
}

export default App;
